/**
 * PDP Sticky Buy Bar — shows when hero CTA leaves viewport.
 * Clicking sticky CTA triggers the main hero form submit.
 */
(function () {
  var stickyBar = document.querySelector('[data-pdp-sticky-bar]');
  var mainCta = document.querySelector('[data-add-to-cart]');
  if (!stickyBar || !mainCta) return;

  // Intersection observer on the main CTA. When the sticky bar becomes
  // visible we publish its height as `--sticky-bottom-bar-height` so that
  // other fixed elements (WhatsApp button, cookie banner) can dodge it
  // via `bottom: calc(... + var(--sticky-bottom-bar-height, 0px))`.
  function publishHeight(visible) {
    var px = visible ? stickyBar.offsetHeight + 'px' : '0px';
    document.documentElement.style.setProperty('--sticky-bottom-bar-height', px);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var visible = entry.isIntersecting;
      var stickyVisible = !visible;
      stickyBar.classList.toggle('is-visible', stickyVisible);
      stickyBar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      document.body.classList.toggle('pdp-sticky-visible', stickyVisible);
      publishHeight(stickyVisible);
    });
  }, {
    rootMargin: '-40px 0px 0px 0px',
    threshold: 0
  });
  observer.observe(mainCta);

  // Update the published height if the bar resizes (long product titles
  // wrap differently across breakpoints).
  if (window.ResizeObserver) {
    new ResizeObserver(function () {
      if (stickyBar.classList.contains('is-visible')) publishHeight(true);
    }).observe(stickyBar);
  }

  // Sticky CTA triggers main form submit
  var stickyCta = stickyBar.querySelector('[data-sticky-add-to-cart]');
  if (stickyCta) {
    stickyCta.addEventListener('click', function () {
      if (!mainCta.disabled) mainCta.click();
    });
  }

  // Keep sticky price in sync with variant changes
  var mainPriceEl = document.querySelector('[data-submit-price]');
  var stickyPriceEl = stickyBar.querySelector('[data-sticky-price]');
  if (mainPriceEl && stickyPriceEl) {
    var mo = new MutationObserver(function () {
      stickyPriceEl.textContent = mainPriceEl.textContent;
    });
    mo.observe(mainPriceEl, { childList: true, characterData: true, subtree: true });
  }
})();
